import { render, staticRenderFns } from "./MotivoDeCambio.vue?vue&type=template&id=30255f89"
import script from "./MotivoDeCambio.vue?vue&type=script&lang=js"
export * from "./MotivoDeCambio.vue?vue&type=script&lang=js"
import style0 from "./MotivoDeCambio.vue?vue&type=style&index=0&id=30255f89&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports